import { render, staticRenderFns } from "./WhatBt.vue?vue&type=template&id=5894d712&scoped=true&"
import script from "./WhatBt.vue?vue&type=script&lang=js&"
export * from "./WhatBt.vue?vue&type=script&lang=js&"
import style0 from "./WhatBt.vue?vue&type=style&index=0&id=5894d712&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5894d712",
  null
  
)

export default component.exports